import React from "react";
import MindsetImg from "../../../../Assets/Images/mindsetImg.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    padding: "16px 0px",
    boxSizing: "border-box",
    marginTop: "10px",
  },
  infoarea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  coverImage: {
    width: "100%",
    height: "300px",
    objectFit: "cover",
  },
  numberContainer: {
    marginTop: "100px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  numberCircle: {
    width: "56px",
    height: "56px",
    borderRadius: "100%",
    border: "4px solid #00577D ",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  numberText: {
    fontSize: "34px",
    fontWeight: "700",
    color: "#00577D",
    fontFamily: "Helvetica, sans-serif",
  },
  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#00577D",
    marginTop: "16px",
    fontFamily: "Helvetica, sans-serif",
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#C99212",
    fontFamily: "Helvetica, sans-serif",
  },
  footer: {
    width: "540px",
    borderTop: "1px solid #00577D",
    paddingTop: "5px",
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "20px",
    left: "20px",
    right: "20px",
  },
  footersection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "400px",
  },
  footerTextheading: {
    fontSize: "10px",
    fontWeight: "700",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
  footerText: {
    fontSize: "8px",
    fontWeight: "400",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
};

const HomeMindset = ({ apiData, previewData, reportType, pageNumber }) => {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)"}}>
    <HeaderPreview apiData={apiData} />
      <div style={styles.page}>
        <div style={styles.infoarea}>
          <img src={MindsetImg} alt="Mindset" style={styles.coverImage} />
          <div style={styles.numberContainer}>
            <div style={styles.numberCircle}>
              <span style={styles.numberText}>4</span>
            </div>
            <div style={styles.title}>GROW</div>
            <div style={styles.subtitle}>YOUR MINDSET</div>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default HomeMindset;
